import * as React from 'react';
import './RbDivider.scss';

class RbDivider extends React.Component<any, any> {

    render() {
        return (
            <hr className="rb-divider" />
        );
    }

}

export default RbDivider;